import { SET_LOCATION, SET_DEVICE_TYPE, SET_MODAL_DATA, SET_SHOW_MODAL, SET_SHOW_LOCATION_PROMPT_OVERLAY, SET_SHOW_IN_APP_NOTIFICATION_OVERLAY, SET_IN_APP_NOTIFICATION_OVERLAY_DATA, SET_ELIGIBLE_LOCATIONS, SET_VPT_STATUS } from "./types";

const initialState = {
    deviceType: "",
    modal: {
        id: null,
        height: "530px",
        isShow: false,
        title: "",
        body: "",
        actions: [],
        forceType: null, //popup, slider
        className: null,
        showCloseButton: true,
        bgColor: "#fff",
        parentID: "",
    },

    locationPromptOverlay: false,

    showInAppNotificationOverlay: false,
    inAppNotificationOverlayData: {},

    vptStatus: null,
    location: null,
    eligibleLocations: [],
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_LOCATION:
            return {
                ...state,
                location: action?.location,
            };

        case SET_VPT_STATUS:
            return {
                ...state,
                vptStatus: action?.status,
            };

        case SET_ELIGIBLE_LOCATIONS:
            return {
                ...state,
                eligibleLocations: action.list || [],
            };

        case SET_SHOW_LOCATION_PROMPT_OVERLAY:
            return {
                ...state,
                locationPromptOverlay: action?.bool,
            };

        case SET_IN_APP_NOTIFICATION_OVERLAY_DATA:
            return {
                ...state,
                inAppNotificationOverlayData: action.data,
            };

        case SET_SHOW_IN_APP_NOTIFICATION_OVERLAY:
            return {
                ...state,
                showInAppNotificationOverlay: action.bool,
            };

        case SET_DEVICE_TYPE:
            return {
                ...state,
                deviceType: action.deviceType,
            };

        case SET_MODAL_DATA:
            return {
                ...state,
                modal: {
                    ...state.modal,
                    ...action.modalData,
                    top: action?.modalData?.top || false,
                    height: action?.modalData?.height || "480px",
                    id: action?.modalData?.id || null,
                    forceType: action?.modalData?.forceType || null,
                    className: action?.modalData?.className || null,
                    bgColor: action?.modalData?.bgColor || "#fff",
                    showCloseButton: action?.modalData?.hasOwnProperty("showCloseButton") ? state?.modalData?.showCloseButton : true,
                    parentID: action?.modalData?.parentID || "",
                },
            };

        case SET_SHOW_MODAL:
            return {
                ...state,
                modal: {
                    ...state.modal,
                    isShow: action.isShow,
                    // id: null,
                },
            };

        default:
            return state;
    }
}
